const getSnowTypes = () => {
  return [
    {
      id: 1,
      name: "New snow < 24h",
      icon: "icon-snowType1"
    },
    {
      id: 2,
      name: "Transformed snow > 24h",
      icon: "icon-snowType2"
    },
    {
      id: 3,
      name: "Spring and old snow",
      icon: "icon-snowType3"
    },
    {
      id: 4,
      name: "Artificial snow",
      icon: "icon-snowType4"
    }
  ];
};

const getSnowType = id => {
  return getSnowTypes().find(snowType => snowType.id === id);
};

export { getSnowTypes, getSnowType };
